module.exports = __webpack_public_path__ + "img/60c8c1fc27d514.89454419.2bf6717e.png";